module.exports = __webpack_public_path__ + "content/9d9df2cc51ba8c85fbd19c45ac50a4f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/sk-pg-logo.svg
// module id = 341
// module chunks = 0